var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSavingIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 53,
    viewBox: "0 0 52 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_217_7633)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9402 12.2098L23.5302 17.8198H21.1202C20.7202 17.8198 20.3302 17.8498 19.9502 17.9298L20.9502 15.5298L20.9902 15.4398L21.0502 15.2798C21.0802 15.2098 21.1002 15.1498 21.1302 15.0998C22.2902 12.4098 23.5902 11.5698 25.9402 12.2098Z",
    fill: "#3E474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.7301 18.0895L32.7101 18.0795C32.1101 17.9095 31.5001 17.8195 30.8801 17.8195H24.6201L26.8701 12.5895L26.9001 12.5195C27.0401 12.5695 27.1901 12.6395 27.3401 12.6895L29.5501 13.6195C30.7801 14.1295 31.6401 14.6595 32.1701 15.2995C32.2601 15.4195 32.3401 15.5295 32.4201 15.6595C32.5101 15.7995 32.5801 15.9395 32.6201 16.0895C32.6601 16.1795 32.6901 16.2595 32.7101 16.3495C32.8601 16.8595 32.8701 17.4395 32.7301 18.0895Z",
    fill: "#3E474F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.52 27.6601H26.77C27.07 27.6601 27.32 27.3901 27.32 27.0601C27.32 26.6401 27.2 26.5801 26.94 26.4801L26.52 26.3301V27.6601Z",
    fill: "#5ED5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.2902 19.5203C31.8402 19.3903 31.3702 19.3203 30.8802 19.3203H21.1202C20.4402 19.3203 19.8002 19.4503 19.2002 19.7103C17.4602 20.4603 16.2402 22.1903 16.2402 24.2003V26.1503C16.2402 26.3903 16.2602 26.6203 16.2902 26.8603C16.5102 30.0403 18.2102 31.7403 21.3902 31.9503C21.6202 31.9803 21.8502 32.0003 22.1002 32.0003H29.9002C33.6002 32.0003 35.5502 30.2403 35.7402 26.7403C35.7502 26.5503 35.7602 26.3503 35.7602 26.1503V24.2003C35.7602 21.9903 34.2902 20.1303 32.2902 19.5203ZM27.2802 25.5003C27.7402 25.6603 28.3602 26.0003 28.3602 27.0603C28.3602 27.9703 27.6502 28.7003 26.7702 28.7003H26.5202V28.9203C26.5202 29.2103 26.2902 29.4403 26.0002 29.4403C25.7102 29.4403 25.4802 29.2103 25.4802 28.9203V28.7003H25.3902C24.4302 28.7003 23.6402 27.8903 23.6402 26.8903C23.6402 26.6003 23.8702 26.3703 24.1602 26.3703C24.4502 26.3703 24.6802 26.6003 24.6802 26.8903C24.6802 27.3103 25.0002 27.6603 25.3902 27.6603H25.4802V25.9703L24.7202 25.7003C24.2602 25.5403 23.6402 25.2003 23.6402 24.1403C23.6402 23.2303 24.3502 22.5003 25.2302 22.5003H25.4802V22.2803C25.4802 21.9903 25.7102 21.7603 26.0002 21.7603C26.2902 21.7603 26.5202 21.9903 26.5202 22.2803V22.5003H26.6102C27.5702 22.5003 28.3602 23.3103 28.3602 24.3103C28.3602 24.6003 28.1302 24.8303 27.8402 24.8303C27.5502 24.8303 27.3202 24.6003 27.3202 24.3103C27.3202 23.8903 27.0002 23.5403 26.6102 23.5403H26.5202V25.2303L27.2802 25.5003Z",
    fill: "#5ED5A8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.6802 24.14C24.6802 24.56 24.8002 24.62 25.0602 24.72L25.4802 24.87V23.54H25.2302C24.9202 23.54 24.6802 23.81 24.6802 24.14Z",
    fill: "#5ED5A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_217_7633",
    x: 0.240234,
    y: 1.00586,
    width: 51.52,
    height: 51.9941,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 5
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.368627 0 0 0 0 0.835294 0 0 0 0 0.658824 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_217_7633"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_217_7633",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSavingIcon);
export default __webpack_public_path__ + "static/media/savingIcon.47c4db85fa637babb9a82bd9992baee3.svg";
export { ForwardRef as ReactComponent };